import React, { useState } from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import PdfLinkActions from "src/components/PdfLinkActions";
import Header from "src/components/wizard/Header";
import Footer from "src/components/wizard/Footer/Footer";

export default function Step1TransferType({ shipment, step, totalSteps, onBack, onSelectType, onClose }) {
  const [selectedType, setSelectedType] = useState("");

  const handleSelectType = (value) => {
    setSelectedType(value);
    // Automatically proceed to next step after selection
    setTimeout(() => {
      onSelectType(value);
    }, 150); // Small delay for visual feedback
  };

  const shipmentInfo = (
    <Box display="flex" alignItems="center" gap={1}>
      <Typography>{shipment?.shipmentId}</Typography>
      <PdfLinkActions
        resourceType="shipment_pdfs"
        resourceId={shipment?.id}
        sx={{
          textTransform: "none",
          fontSize: 12,
          py: 0.2,
          px: 1,
          minWidth: "auto",
          height: 25,
          borderRadius: 10,
        }}
      />
    </Box>
  );

  return (
    <>
      <Header
        title="Transfer Type"
        info={shipmentInfo}
      />
      <Box
        p={2}
        minHeight={400}
        display="flex"
        flexDirection="column"
        justifyContent="space-between"
      >
        <Box py={2}>
          <Typography fontSize={16} align="center" color="text.primary" sx={{ mb: 3 }}>
            Are you transferring the entire shipment or only specific items?
          </Typography>
          <FormControl fullWidth>
            <RadioGroup
              value={selectedType}
              onChange={(e) => handleSelectType(e.target.value)}
            >
              <FormControlLabel
                value="full"
                control={<Radio />}
                label={
                  <Box>
                    <Typography variant="body1" fontWeight={500}>
                      Entire Shipment
                    </Typography>
                    <Typography variant="body2" color="textSecondary">
                      All items will be transferred to a new customer
                    </Typography>
                  </Box>
                }
                sx={{ mb: 2, p: 2, border: "1px solid #e0e0e0", borderRadius: 1 }}
              />
              <FormControlLabel
                value="partial"
                control={<Radio />}
                label={
                  <Box>
                    <Typography variant="body1" fontWeight={500}>
                      Partial Transfer
                    </Typography>
                    <Typography variant="body2" color="textSecondary">
                      Select specific items to move to a new shipment
                    </Typography>
                  </Box>
                }
                sx={{ p: 2, border: "1px solid #e0e0e0", borderRadius: 1 }}
              />
            </RadioGroup>
          </FormControl>
        </Box>
      </Box>
      <Footer step={step} steps={totalSteps} showRaceMode={false}>
        <Button variant="outlined" onClick={onBack}>
          Back
        </Button>
      </Footer>
    </>
  );
}
